import axios from 'axios'
import auth from '../utils/auth'
import cfg from '../utils/config'

const getHeaders = () => ({
    headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${auth.getToken()}`
    }
})

const userInfo = () => {
    return auth.getUserInfo()
}

const getCompanyDetails = async (companyId) => {
    const baseURL = companyId == userInfo().empresa
        ? `${cfg.base_api_url}${cfg.api_v2}/${userInfo().empresa}/empresa/minha/`
        : `${cfg.base_api_url}${cfg.api_v2}/${userInfo().empresa}/empresa/${companyId}/`

    try {
        const res = await axios.get(`${baseURL}`, getHeaders())

        const detalhes = { ...(res.data || {}) }
        delete detalhes.id

        Object.keys(detalhes).forEach(key => {
            if (detalhes[key] == null) detalhes[key] = ""
        })

        return detalhes
    } catch (error) {
        console.error('Erro ao buscar detalhes da empresa:', error)
        return {}
    }
}

const updateMyCompanyDetails = async (payload) => {
    const baseURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo().empresa}/empresa/minha/`

    try {
        const res = await axios.patch(`${baseURL}`, getHeaders(), payload)

        const detalhes = { ...(res.data || {}) }
        delete detalhes.id

        Object.keys(detalhes).forEach(key => {
            if (detalhes[key] == null) detalhes[key] = ""
        })

        return detalhes
    } catch (error) {
        console.error('Erro ao buscar detalhes da empresa:', error)
        return {}
    }
}

const getCompanyAddresses = async (companyId) => {
    const baseURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo().empresa}/empresa/${companyId}`
    try {
        const res = await axios.get(`${baseURL}/endereco/`, getHeaders())
        return res.data?.results ?? []
    } catch (error) {
        console.error('Erro ao buscar endereços da empresa:', error)
        return []
    }
}

const saveCompanyAddresses = async (companyId, payload) => {
    const baseURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo().empresa}/empresa/${companyId}`
    try {
        const res = payload.id
            ? await axios.patch(`${baseURL}/endereco/${payload.id}/`, payload, getHeaders())
            : await axios.post(`${baseURL}/endereco/`, payload, getHeaders())

        return res
    } catch (error) {
        console.error('Erro ao salvar endereço da empresa:', error)
        return []
    }
}

const deleteCompanyAddresses = async (companyId, addressId) => {
    const baseURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo().empresa}/empresa/${companyId}`
    try {
        const res = await axios.delete(`${baseURL}/endereco/${addressId}/`, getHeaders())

        return res
    } catch (error) {
        console.error('Erro ao salvar endereço da empresa:', error)
        return []
    }
}

const getCompanyContacts = async (companyId) => {
    const baseURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo().empresa}/empresa/${companyId}`

    try {
        const res = await axios.get(`${baseURL}/contato/`, getHeaders())
        return res.data?.results ?? []
    } catch (error) {
        console.error('Erro ao buscar contatos da empresa:', error)
        return []
    }
}

const saveCompanyContacts = async (companyId, payload) => {
    const baseURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo().empresa}/empresa/${companyId}`

    try {
        const res = payload.id
            ? await axios.patch(`${baseURL}/contato/${payload.id}/`, payload, getHeaders())
            : await axios.post(`${baseURL}/contato/`, payload, getHeaders())

        return res
    } catch (error) {
        console.error('Erro ao salvar contato da empresa:', error)
        return []
    }
}

const deleteCompanyContacts = async (companyId, contactId) => {
    const baseURL = `${cfg.base_api_url}${cfg.api_v2}/${userInfo().empresa}/empresa/${companyId}`

    try {
        const res = await axios.delete(`${baseURL}/contato/${contactId}/`, getHeaders())

        return res
    } catch (error) {
        console.error('Erro ao deletar contato da empresa:', error)
        return []
    }
}

const getCompanyFullData = async (companyId) => {
    try {
        const [detalhes, enderecos, contatos] = await Promise.all([
            getCompanyDetails(companyId),
            getCompanyAddresses(companyId),
            getCompanyContacts(companyId)
        ])

        return {
            detalhes,
            enderecos,
            contatos
        }

    } catch (error) {
        console.error('Erro ao buscar dados completos da empresa:', error)

        return {
            detalhes: {},
            enderecos: [],
            contatos: []
        }
    }
}

export {
    getCompanyDetails,
    getCompanyAddresses,
    saveCompanyAddresses,
    deleteCompanyAddresses,
    getCompanyContacts,
    saveCompanyContacts,
    deleteCompanyContacts,
    getCompanyFullData,
    updateMyCompanyDetails,
}